module.exports = __webpack_public_path__ + "static/media/ghcl.ecab0357.svg";